import React, { useState, useRef } from 'react';
import "../css/Debrief.css";
import CHOPHeader from "./CHOPHeader";
import PicuHeader from "./PicuHeader";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { withStyles } from '@mui/styles';
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Rating from '@mui/material/Rating';
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import saveData from '../services/saveData';
import WriteToLog from '../services/WriteToLog';

const checkBoxStyles = theme => ({
  root: {
    '&$checked': {
      color: '#005587',
    },
  },
  checked: {},
 })

const CustomCheckbox = withStyles(checkBoxStyles)(Checkbox);

const StyledRating = withStyles({
  iconFilled: {
    color: '#005587',
  },
  iconHover: {
    color: '#ff3d47',
  },
})(Rating);

const Debrief = () => {
  const title = "Debrief";
  const note = "";
  const navigate = useNavigate();

  const location = useLocation();
  const { selectedPatient } = location.state;
  const banner = selectedPatient.need_patient_banner;
  const room = selectedPatient.ROOM + " " + selectedPatient.BED;
  const name = selectedPatient.DISPLAY_NAME;
  const mrn = selectedPatient.MRN;
  const dob = selectedPatient.DOB;
  const gender = selectedPatient.gender;
  const age = selectedPatient.DISPLAY_AGE;
  const planLink = <NavLink to="/assessment" className='list-link' state={{ selectedPatient: selectedPatient }}>Plan</NavLink>

  const [OVERALL_TEAM_PERFORM, setOverallValue] = React.useState(0);
  const [TEAMWORK, setTeamworkValue] = React.useState(0);
  const [COMMUNICATION, setCommunicationValue] = React.useState(0);

  const [OVERCROWDING, setOvercrowdingValue] = React.useState('');
  const handleOvercrowding = (event) => {
    if (event.target.checked) {
      setOvercrowdingValue(event.target.value);
    } else {
      setOvercrowdingValue('');    
    }
  };

  const [OVERCROWDING_NOTES, setOvercrowdingNotes] = useState('');

  const [UNDERSTAFFED, setUnstaffedValue] = React.useState('');
  const handleUnstaffed = (event) => {
    if (event.target.checked) {
      setUnstaffedValue(event.target.value);
    } else {
      setUnstaffedValue('');    
    }
  };

  const [UNDERSTAFFED_NOTES, setUnderstaffedNotes] = useState('');

  const [EQUIPMENT, setEquipmentValue] = React.useState('');
  const handleEquipment = (event) => {
    if (event.target.checked) {
      setEquipmentValue(event.target.value);
    } else {
      setEquipmentValue('');    
    }
  };

  const [EQUIPMENT_NOTES, setEquipmentNotes] = useState('');

  const [MEDICATION_ADMINISTRATION, setMedicationValue] = React.useState('');
  const handleMedication = (event) => {
    if (event.target.checked) {
      setMedicationValue(event.target.value);
    } else {
      setMedicationValue('');    
    }
  };

  const [MEDICATION_ADMINISTRATION_NOTES, setMedicationNotes] = useState('');

  const [LAST_MINUTE_PLAN_CHANGES, setLastminuteValue] = React.useState('');
  const handleLastminute = (event) => {
    if (event.target.checked) {
      setLastminuteValue(event.target.value);
    } else {
      setLastminuteValue('');    
    }
  };

  const [LAST_MINUTE_PLAN_CHANGES_NOTES, setLastminuteNotes] = useState('');
  const [OTHER_COMMENTS, setComments] = useState('');

  const [requiredError, setRequiredError] = React.useState('');
  const [requiredTeamworkError, setRequiredTeamworkError] = React.useState('');
  const [requiredCommunicationError, setRequiredCommunicationError] = React.useState('');

  /* Save Debrief form */
  const planForm = useRef();

  const handleSubmit = async(e) => {
    e.preventDefault();
    e.stopPropagation();

    const data = {OVERALL_TEAM_PERFORM, TEAMWORK, COMMUNICATION, OVERCROWDING, OVERCROWDING_NOTES, UNDERSTAFFED, UNDERSTAFFED_NOTES, EQUIPMENT, EQUIPMENT_NOTES, MEDICATION_ADMINISTRATION, MEDICATION_ADMINISTRATION_NOTES, LAST_MINUTE_PLAN_CHANGES, LAST_MINUTE_PLAN_CHANGES_NOTES, OTHER_COMMENTS};
    var today = new Date();
    var currentdatetime = today.getFullYear() + '-' + ("0"+(today.getMonth()+1)).slice(-2) + '-' + ("0"+today.getDate()).slice(-2) + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    data.CREATE_DATETIME = currentdatetime;

    if (data.OVERALL_TEAM_PERFORM !== 0 && data.TEAMWORK !== 0 && data.COMMUNICATION !== 0) {
      /* Save Debrief data to EHR */
      let ehrValue = JSON.stringify(data);
      let ehrResponse = await saveData(selectedPatient.PATIENT_ID, selectedPatient.CSN, selectedPatient.debriefId, ehrValue, selectedPatient.USER_ID, selectedPatient.fhir_server, selectedPatient.access_token);
      //WriteToLog("After saveData Debrief response: " + ehrResponse); 
      if (ehrResponse === "success") {    
        WriteToLog('Debrief saved successfully for patient: ' + selectedPatient.PATIENT_ID); 
        if (planForm.current.buttonId === 'update') {
          navigate('/assessment', { state: { selectedPatient:selectedPatient } });
        }
        if (planForm.current.buttonId === 'close') {
          navigate('/selected', { state: { selectedPatient:selectedPatient } });
        }
      } else {
        WriteToLog("Debrief not saved to EHR for patient: " + selectedPatient.PATIENT_ID + " ehrResponse " + ehrResponse);
        navigate('/error', { state: { selectedPatient : selectedPatient, failure: "trying to save Debrief into EHR" } });
      }
    } else {
      /* Display Error Message */
      if (data.OVERALL_TEAM_PERFORM === 0) {
        setRequiredError("This field is required");
      }
      if (data.TEAMWORK === 0) {
        setRequiredTeamworkError("This field is required");
      }
      if (data.COMMUNICATION === 0) {
        setRequiredCommunicationError("This field is required");
      }
    }
  };

  return (
    <div className="Debrief">
      <CHOPHeader planLink={planLink} />
      <PicuHeader banner={banner} room={room} name={name} mrn={mrn} dob={dob} age={age} gender={gender} title={title} note={note} />
      <h5>Team Feedback</h5>
      <hr/>

      <form onSubmit={handleSubmit} ref={planForm}>
      <Container fluid="md">
      <Row>
        <Col xs={7} sm={8} md={8} lg={8}>How well did the team perform during the procedure overall?<p className="rating-note">On a scale of 1-5, 5 being the best</p></Col>
        <Col xs={3} sm={4} md={4} lg={4}><StyledRating name="overall" value={OVERALL_TEAM_PERFORM} onChange={(event, newValue) => { setOverallValue(newValue); setRequiredError(''); }} /></Col>
      </Row>
      {requiredError !== '' && (<span className="custom-error-font">{requiredError}</span>)}
      <Row className="debrief-bottom-space">
        <Col sm={9}>As a group, rank how well the team performed on the following:</Col>
        <Col sm={3}></Col>
      </Row>
      <Row className="debrief-bottom-space">
        <Col xs={7} sm={8} md={8} lg={8}><span className="debrief-left-space">Teamwork</span></Col>
        <Col xs={3} sm={4} md={4} lg={4}><StyledRating name="teamwork" value={TEAMWORK} onChange={(event, newValue) => { setTeamworkValue(newValue); setRequiredTeamworkError(''); }} /></Col>
      </Row>
      {requiredTeamworkError !== '' && (<span className="custom-error-font">{requiredTeamworkError}</span>)}
      <Row>
        <Col xs={7} sm={8} md={8} lg={8}><span className="debrief-left-space">Communication</span></Col>
        <Col xs={3} sm={4} md={4} lg={4}><StyledRating name="communication" value={COMMUNICATION} onChange={(event, newValue) => { setCommunicationValue(newValue); setRequiredCommunicationError(''); }} /></Col>
      </Row>
      {requiredCommunicationError !== '' && (<span className="custom-error-font">{requiredCommunicationError}</span>)}
      </Container>
      <hr/>

      <Container fluid="md">
      <Row className="debrief-bottom-space">
        <Col sm={8}><span>Were there issues with any of the following:</span></Col>
        <Col sm={4}></Col>
      </Row>
      <Row>
        <Col xs={8} sm={8} md={8} lg={8}><span className="debrief-left-space">Overcrowding</span></Col>
        <Col xs={4} sm={4} md={4} lg={4}>
          <CustomCheckbox checked={OVERCROWDING === 'Y'} value="Y" onChange={handleOvercrowding} slotProps={{ 'aria-label': 'controlled' }} />
          </Col>
      </Row>
      {OVERCROWDING === 'Y' ? (
          <Row className="adjust-row-width debrief-left-space">
            <TextField
              label="How did this impact the procedure?"
              multiline
              minRows={1}
              variant="filled"
              value={OVERCROWDING_NOTES} onChange={e => setOvercrowdingNotes(e.target.value)}
              slotProps={{
                style: {
                    backgroundColor: "#f6f6f6"
                }
              }}
            />
          </Row>
        ) : (
          ''
        )}
      <Row>
        <Col xs={8} sm={8} md={8} lg={8}><span className="debrief-left-space">Understaffed</span></Col>
        <Col xs={4} sm={4} md={4} lg={4}>
        <CustomCheckbox checked={UNDERSTAFFED === 'Y'} value="Y" onChange={handleUnstaffed} slotProps={{ 'aria-label': 'controlled' }} />
          </Col>
      </Row>
      {UNDERSTAFFED === 'Y' ? (
          <Row className="adjust-row-width debrief-left-space">
            <TextField
              label="How did this impact the procedure?"
              multiline
              minRows={1}
              variant="filled"
              value={UNDERSTAFFED_NOTES} onChange={e => setUnderstaffedNotes(e.target.value)}
              slotProps={{
                style: {
                    backgroundColor: "#f6f6f6"
                }
              }}
            />
          </Row>
        ) : (
          ''
        )}
      <Row>
        <Col xs={8} sm={8} md={8} lg={8}><span className="debrief-left-space">Equipment</span></Col>
        <Col xs={4} sm={4} md={4} lg={4}>
        <CustomCheckbox checked={EQUIPMENT === 'Y'} value="Y" onChange={handleEquipment} slotProps={{ 'aria-label': 'controlled' }} />
          </Col>
      </Row>
      {EQUIPMENT === 'Y' ? (
          <Row className="adjust-row-width debrief-left-space">
            <TextField
              label="How did this impact the procedure?"
              multiline
              minRows={1}
              variant="filled"
              value={EQUIPMENT_NOTES} onChange={e => setEquipmentNotes(e.target.value)}
              slotProps={{
                style: {
                    backgroundColor: "#f6f6f6"
                }
              }}
            />
          </Row>
        ) : (
          ''
        )}
      <Row>
        <Col xs={8} sm={8} md={8} lg={8}><span className="debrief-left-space">Medication Administration</span></Col>
        <Col xs={4} sm={4} md={4} lg={4}>
          <CustomCheckbox checked={MEDICATION_ADMINISTRATION === 'Y'} value="Y" onChange={handleMedication} slotProps={{ 'aria-label': 'controlled' }} />
          </Col>
      </Row>
      {MEDICATION_ADMINISTRATION === 'Y' ? (
          <Row className="adjust-row-width debrief-left-space">
            <TextField
              label="How did this impact the procedure?"
              multiline
              minRows={1}
              variant="filled"
              value={MEDICATION_ADMINISTRATION_NOTES} onChange={e => setMedicationNotes(e.target.value)}
              slotProps={{
                style: {
                    backgroundColor: "#f6f6f6"
                }
              }}
            />
          </Row>
        ) : (
          ''
        )}
      <Row>
        <Col xs={8} sm={8} md={8} lg={8}><span className="debrief-left-space">Last minute plan changes</span></Col>
        <Col xs={4} sm={4} md={4} lg={4}>
        <CustomCheckbox checked={LAST_MINUTE_PLAN_CHANGES === 'Y'} value="Y" onChange={handleLastminute} slotProps={{ 'aria-label': 'controlled' }} />
          </Col>
      </Row>
      {LAST_MINUTE_PLAN_CHANGES === 'Y' ? (
          <Row className="adjust-row-width debrief-left-space">
            <TextField
              label="How did this impact the procedure?"
              multiline
              minRows={1}
              variant="filled"
              value={LAST_MINUTE_PLAN_CHANGES_NOTES} onChange={e => setLastminuteNotes(e.target.value)}
              slotProps={{
                style: {
                    backgroundColor: "#f6f6f6"
                }
              }}
            />
          </Row>
        ) : (
          ''
        )}
      <Row>
        <Col xs={8} sm={8} md={8} lg={8}>Any other comments?</Col>
        <Col xs={4} sm={4} md={4} lg={4}></Col>
      </Row>
      <Row className="adjust-row-width debrief-left-space bottom-space">
      <TextField multiline minRows={1} aria-label="comments" variant="outlined" value={OTHER_COMMENTS} onChange={e => setComments(e.target.value)} placeholder="Please describe" />
      </Row>
      <div id="two-buttons">
        <button type="submit" className="submit-btn-1" id="update" onClick={e => planForm.current.buttonId=e.target.id}>Save & Update Plan</button>
        <button type="submit" className="submit-btn-2" id="close" onClick={e => planForm.current.buttonId=e.target.id}>Save & Close</button>
      </div>
      </Container>
      </form>
    </div> 
  );
}

export default Debrief;
